import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { translations } from "../../../utils/translations";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";

const Banner = styled.img`
  height: auto;
  display: block;

  width: 150%;

  @media (min-width: 600px) {
    width: 100%;
    max-width: 100vw;
  }
`;

const Ribbon = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 6rem;
  align-items: center;
  border-bottom: 2px solid var(--white-gray-color);
  padding-bottom: 2rem;

  @media (max-width: 600px) {
    gap: 1.5rem;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  a,
  button {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--primary-brown);
    text-decoration: none;
    font-weight: bold;
    font-family: Georgia, sans-serif;
    position: relative;
    margin-top: -20px;
    font-size: 16px;

    @media (max-width: 1200px) {
      margin-top: -20px;
      font-size: 14px;
    }

    @media (max-width: 900px) {
      margin-top: -10px;
    }

    @media (max-width: 550px) {
      margin-top: -5px;
      font-size: 8px;
    }
  }
`;

const Img = styled.img`
  width: 100%;
  height: auto;
  display: block;
  max-width: 15vw;

  @media (max-width: 530px) {
    max-width: 24vw;
  }
`;

const AboutSection = styled.div`
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;

  gap: 3rem;

  @media (min-width: 1000px) {
    padding: 2rem 10rem;
  }

  @media (min-width: 700px) {
    padding: 2rem 2rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const ImgVertical = styled.img`
  width: 100%;
  height: auto;
  max-width: 50vw;

    @media (min-width: 700px) {
    max-width: 40vw;
  }
  @media (min-width: 1000px) {
    max-width: 30vw; !important;
  }


  @media (min-width: 500px) {
  }
`;

const ImgHorizontal = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  max-height: 30vh;
  min-width: 50vw;
`;

const AboutDescriptionSection = styled.div`
  h2 {
    font-family: Verdana, sans-serif;
  }

  p {
    text-align: justify;
    font-family: Verdana, sans-serif;
  }
  li {
    padding: 0.5rem 0;
  }
`;

const HomePage = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);

  const aboutRef = useRef(null);
  const printRef = useRef(null);

  const [isMobile, setIsMobile] = useState(false);
  const checkScreenSize = () => {
    setIsMobile(window.matchMedia("(max-width: 820px)").matches);
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Smooth scroll function to About Us section
  const scrollToAbout = (section) => {
    section.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <Banner
        src={isMobile ? "/images/banner-small.png" : "/images/banner.png"}
        alt="banner"
      />
      <Ribbon>
        <ImgContainer>
          <Img src={"/images/ribbon1 (1).png"} alt="ribbon1" />

          <button
            onClick={() => scrollToAbout(printRef)}
            style={{
              background: "none",
              border: "none",
            }}
          >
            {translations[languageCode]["home-read-more"]}
            <FaArrowRight />
          </button>
        </ImgContainer>

        <ImgContainer>
          <Img src={"/images/ribbon2 (1).png"} alt="ribbon2" />
          <Link to="/projects">
            {translations[languageCode]["home-read-more"]}
            <FaArrowRight />
          </Link>
        </ImgContainer>

        <ImgContainer>
          <Img src={"/images/ribbon3 (1).png"} alt="ribbon3" />
          <button
            onClick={() => scrollToAbout(aboutRef)}
            style={{
              background: "none",
              border: "none",
            }}
          >
            {translations[languageCode]["home-read-more"]}
            <FaArrowRight />
          </button>
        </ImgContainer>
      </Ribbon>

      <AboutSection ref={aboutRef}>
        {isMobile ? (
          <ImgHorizontal src={"/images/prezentation.png"} alt="about-us" />
        ) : (
          <ImgVertical src={"/images/prezentation.png"} alt="about-us" />
        )}
        <AboutDescriptionSection>
          <h2>{translations[languageCode]["home-about-us"]}</h2>
          <p>
            Totul a început dintr-o necesitate. La început, întâmpinam adesea
            dificultăți în a găsi piesele specifice de care aveam nevoie. Fie nu
            le găseam deloc în comerț, fie prețul lor era exagerat de mare
            pentru bugetul nostru. Mai mult, de multe ori, negăsind o piesă de
            schimb pentru diverse obiecte stricate, era necesar să achiziționăm
            un întreg produs, ceea ce adăuga costuri suplimentare și genera
            risipa.
          </p>
          <p>
            Astfel, am început să explorăm tehnologia de printare 3D pentru a
            proiecta și fabrica obiecte personalizate, adaptate perfect nevoilor
            noastre, reușind nu doar să economisim bani, dar și să obținem
            piesele exact așa cum le imaginam, fără a mai depinde de opțiunile
            standard disponibile pe piață.
          </p>
          <p>
            Astăzi, misiunea noastră este să îți oferim nu doar un serviciu de
            printare 3D, ci și consultanță în design și personalizare, pentru a
            transforma ideile tale în realitate, fără compromisuri.
          </p>
        </AboutDescriptionSection>
      </AboutSection>
      <AboutSection ref={printRef}>
        <AboutDescriptionSection>
          <h2>{translations[languageCode]["home-about-printing"]}</h2>
          <p>
            Printarea 3D, cunoscută și sub denumirea de fabricare aditivă, este
            un proces de creare a unui obiect fizic prin adăugarea succesivă de
            straturi de material. Această tehnologie permite transformarea unui
            model digital 3D într-un obiect tangibil, folosind diverse tipuri de
            materiale, denumite filament. Printarea 3D este folosită într-o gamă
            largă de domenii, de la prototipurile industriale, designul de
            produs, până la creațiile personalizate pentru hobby-uri și arte.
          </p>
          <div>
            Există mai multe tipuri de filament, fiecare cu propriile sale
            caracteristici și aplicații specifice. Iată câteva dintre cele mai
            populare:
            <ul>
              <li>
                <b>PLA:</b> fiind unul dintre cele mai utilizate tipuri de
                filament, acesta este fabricat din amidon de porumb sau trestie
                de zahăr, ceea ce îl face biodegradabil.
              </li>
              <li>
                <b>PETG:</b> foarte similar cu cel regăsit la fabricarea
                recipientelor de plastic pentru băuturi, este un filament
                rezistent, ușor flexibil și ușor de utilizat.
              </li>
              <li>
                <b>ABS:</b> un filament puternic și durabil, adesea folosit
                pentru piesele de schimb sau obiectele care trebuie să reziste
                la temperaturi ridicate în timpul utilizării.
              </li>
              <li>
                <b>TPU: </b> este un filament flexibil și elastic, ceea ce îl
                face ideal pentru crearea de obiecte care necesită o anumită
                elasticitate.
              </li>
            </ul>
          </div>
        </AboutDescriptionSection>
        {isMobile ? (
          <ImgHorizontal src={"/images/prez2.png"} alt="about-printing" />
        ) : (
          <ImgVertical src={"/images/prez2.png"} alt="about-printing" />
        )}
      </AboutSection>
    </>
  );
};

export default HomePage;
